import { arrayOf, oneOf, shape, string } from "prop-types";
import { useMemo } from "react";

import FnrTypography from "FnrTypography";

import arrayToCommaAnd from "Utilities/arrayToCommaAnd";

const AdditionalDesignationsText = ({ designations }) => {
  const aogTitles = useMemo(() => {
    return designations
      .filter(({ addOnGiftID }) => Boolean(addOnGiftID))
      .map(({ title }) => title);
  }, [designations]);

  const aogText = useMemo(() => {
    if (aogTitles.length <= 0) return undefined;
    return `+ ${arrayToCommaAnd(aogTitles)}`;
  }, [aogTitles]);

  if (!aogText) return null;
  return (
    <FnrTypography role="note" color="textSecondary">
      {aogText}
    </FnrTypography>
  );
};

AdditionalDesignationsText.propTypes = {
  designations: arrayOf(
    shape({
      fundName: string.isRequired,
      type: oneOf(["CoverTheFees", "Percentage", "Amount"]).isRequired,
    })
  ).isRequired,
};

export default AdditionalDesignationsText;
